import React, { useEffect } from "react";
import "./styles.scss";
import { LoginForm } from "../../schoolUiComponents/loginForm";
import { useAuthSigninState } from "../../authSignin/state";
import { setupHideElementsObserver } from "../../teacherDashboard/teacher/config/common";

export const StudentUsernameLogin = () => {
  const { sendEvent } = useAuthSigninState();
  
  useEffect(() => {
    // Set up observer to hide consent and overlay elements
    const cleanupObserver = setupHideElementsObserver();

    return () => {
      // Clean up observer and restore elements
      cleanupObserver();
    }
  }, []);

  return (
    <div className="student-username-login">
      <button className="login-back dark" onClick={() => window.location.hash = ""} aria-label="Go back"><i className="iconcust-iconBackBtn"></i></button>
      <h4>Student Log In</h4>
      <LoginForm showOTPLoginOption={false} primaryInputLabel="Username" showForgotPassword={false} source="Class Login" showSocialLogin={false} sendEvent={sendEvent}/>
    </div>
  );
};